<nz-card class="round-border p-4" [nzLoading]="!loaded">
    <a [routerLink]="['/marker']">
        <nz-statistic [nzValue]="count | number" [nzTitle]="'marker_common_name' | translate"></nz-statistic>
    </a>
</nz-card>